import React from 'react';

function CookieGerman() {
  return (
    <div>
      <h1>COOKIE-RICHTLINIE</h1>
      Vivian Lab URL: https://vivianlab.com
      <br />
      <br />
      Erklärung: Durch den Zugriff auf diese Website und die fortgesetzte Nutzung erklären Sie sich
      ausdrücklich mit der folgenden Cookie-Richtlinie einverstanden. Letzte Überarbeitung: 16.
      November 2023
      <br />
      <br />
      ALLGEMEINES
      <br />
      Das „Unternehmen“ hält sich an strenge Richtlinien zum Schutz der Privatsphäre der Besucher der
      „Website“. Mit diesem Hinweis informieren wir Sie darüber, wie wir elektronische Cookies –
      COOKIES – verwenden, wenn Sie unsere Website besuchen. Wir halten es für wichtig, dass der
      Nutzer darüber informiert ist, welche Cookies wir auf unserer Website verwenden und aus welchen
      Gründen wir sie einsetzen. Unser Ziel ist eine korrekte Information sowie eine bessere und
      sichere Navigation auf der Website unseres Unternehmens.
      <br />
      DEFINITION Was sind Cookies? <br />
      <br />
      Elektronische Cookies sind kurze Software-Codes, die vom Online-Server unseres Unternehmens
      („Server“) zur Speicherung an Ihr Endgerät gesendet werden und deren grundlegende Funktion
      darin besteht, mithilfe der Daten Ihres Browsers („Browser“) mit uns zu kommunizieren. Je nach
      ihrer Dauer werden Cookies entweder als „temporär“ (Sitzungs-Cookies) oder als „dauerhaft“
      (dauerhafte Cookies) bezeichnet. „Temporäre Cookies“ sind Cookies, die automatisch gelöscht
      werden, wenn Sie Ihren Browser schließen, während „dauerhafte Cookies“ bis zum Ablauf ihrer
      festgelegten Gültigkeitsdauer auf Ihrem Endgerät gespeichert bleiben. Die Annahme und Verwendung
      von Cookies verursacht keinerlei Schaden an dem von Ihnen verwendeten Endgerät, wie
      beispielsweise PC, Smartphone oder Tablet, noch an den darauf gespeicherten Dateien.
      <br />
      <br />
      GRÜNDE FÜR DIE VERWENDUNG VON COOKIES
      <br />
      Verwendet unsere Website Cookies?
      <br />
      Wir verwenden einige elektronische Cookies, deren Hauptzweck darin besteht, unsere Website
      „www.vivianlab.com“ funktionaler und benutzerfreundlicher zu gestalten, ihre allgemeine
      Funktionsweise zu verbessern, eine korrekte und schnelle Navigation zu gewährleisten sowie eine
      einfache Verbindung und reibungslosen Wechsel zu den einzelnen Seiten zu ermöglichen. Darüber
      hinaus werden Cookies verwendet, um dem Besucher/Nutzer den Zugang zu den Diensten der „Website“
      zu erleichtern, aber auch zu statistischen Zwecken, um die Bereiche zu ermitteln, in denen die
      Dienste der „Website“ nützlich oder beliebt sind. Alle durch diese Cookies gesammelten
      Informationen werden verwendet, um das Einkaufserlebnis, die Struktur, den Inhalt und die
      Reaktionsgeschwindigkeit unserer Website zu verbessern. Außerdem erreichen wir durch den Einsatz
      von Cookies die kontinuierliche Optimierung des Betriebs der Website und der Bereitstellung der
      Dienste unseres Unternehmens sowie die sofortige Behebung etwaiger auftretender Probleme.
      <br />
      <br />
      ARTEN VON COOKIES, DIE WIR VERWENDEN.
      <br />
      Cookie-Technologie und insbesondere:
      <br />
      Die „temporären Cookies“ (Sitzungscookies) für folgende Zwecke:
      <br />- Um Sie nach der Anmeldung automatisch als registrierten Nutzer zu identifizieren oder
      um sichere Unterseiten zu besuchen.
      <br />
      - Zur automatischen Identifizierung bei der Durchführung von Transaktionen sowie bei der Nutzung
      unserer Dienste, die für den Betrieb der üblichen Dienstauswahlanwendung erforderlich sind.
      <br />
      - Zur Verteilung der Bearbeitung von Serveranfragen auf eine Gruppe von Servern.
      <br />
      - Zur elektronischen Identifizierung von Nutzern, die bereits mit sozialen Medien verbunden sind.
      <br />
      Darüber hinaus verwenden wir „dauerhafte Cookies“ für folgende Zwecke:
      <br />
      - Zur Verbesserung der Leistung unserer Website.
      <br />
      - Zur Personalisierung Ihrer Benutzeroberfläche und zur Anpassung der Funktionsweise unserer
      Website.
      <br />
      <br />
      <br />
      KATEGORIEN Von uns verwendete Cookies
      <br />
      1) Notwendige Cookies
      <br />
      <br />
      Sie ermöglichen die Ausführung grundlegender Funktionen der Website, wie z. B. das Hinzufügen
      von Diensten, Online-Zahlungen und das Speichern Ihrer Auswahl und Präferenzen in der
      Dienstliste. Ohne diese absolut notwendigen Cookies wird der reibungslose Betrieb unserer
      Website unmittelbar beeinträchtigt, aber auch das persönliche Navigationserlebnis
      verschlechtert sich, da die für die Online-Nutzung wesentlichen Optionen und Funktionen
      eingeschränkt sind.
      <br />
      2) Leistungs-Cookies
      <br />
      Diese Cookies sammeln Informationen darüber, wie Besucher unsere Website nutzen. Sie
      ermöglichen es uns zu erkennen, welche Seiten am häufigsten besucht werden, oder zeigen uns, ob
      bei der Navigation Probleme auftreten. Diese Cookies sammeln keine Informationen, die den
      Besucher identifizieren. Alle durch diese Cookies gesammelten Informationen werden aggregiert und
      ausschließlich dazu verwendet, die Funktionsweise unserer Website zu verbessern.
      <br />
      3) Funktions-Cookies
      <br />
      Diese Cookies „merken“ sich die Präferenzen des Nutzers beim Surfen auf unserer Website, sodass
      wir ihm anschließend entsprechend seinen Bedürfnissen passende Dienste und Optionen empfehlen
      können. Mit diesen Cookies wird eine personalisierte Version der Website erstellt, die es dem
      Nutzer erheblich erleichtert, das Gesuchte zu finden.
      <br />
      4) Werbe-Cookies
      <br />
      Diese Cookies werden verwendet, um Werbung bereitzustellen, die für jeden Nutzer und dessen
      Interessen relevanter ist. Sie dienen auch dazu, gezielte Werbung oder Angebote zu senden, mit dem
      Ziel, Massenwerbung, Spam und irrelevante Werbebotschaften für den Nutzer zu begrenzen.
      Gleichzeitig helfen sie dabei, die Wirksamkeit von Werbekampagnen zu messen.
      <br />
      5) Analyse-Cookies
      <br />
      Sie sind eine Untergruppe der Funktions-Cookies und ermöglichen es uns, die Wirksamkeit der
      verschiedenen Funktionen unserer Website zu bewerten, damit wir das Nutzererlebnis kontinuierlich
      verbessern können.
      <br />
      Im Einzelnen:
      <br />
      <br />
      Drittanbieter, einschließlich Google, können Unternehmenswerbung auf Internetseiten anzeigen.
      <br />
      Drittanbieter, einschließlich Google, können Cookies verwenden, um Werbung auf der Grundlage des
      vorherigen Besuchs des Nutzers auf unserer Website zu aktualisieren, zu optimieren und
      anzuzeigen.
      <br />
      Die Website kann auch Cookies aus einem früheren Besuch auf ihrer Website für Remarketingzwecke
      verwenden.
      <br />
      Der Nutzer kann einer solchen Verwendung von Cookies über die vom jeweiligen Browser angebotenen
      Optionen und Verfahren widersprechen.
      <br />
      Der Nutzer kann den Browser so einstellen, dass er jedes Mal vor dem Herunterladen eines Cookies
      informiert wird und somit entscheiden kann, ob er es herunterladen oder ablehnen möchte. In
      diesem Fall weisen wir darauf hin, dass möglicherweise nicht alle Funktionen genutzt werden
      können.
      <br />
      Die Website kann Google-Analytics-Funktionen für Display-Anzeigen nutzen (z. B. Remarketing,
      Impression-Berichte des Google Display-Netzwerks, Integration des DoubleClick Campaign Managers
      sowie demografische und Interessenberichte).
      <br />
      Über die Anzeigeneinstellungen können Nutzer Google Analytics für Display-Anzeigen deaktivieren
      und Anzeigen im Google Display-Netzwerk anpassen.
      <br />
      Hier finden Sie die{' '}
      <a href="https://tools.google.com/dlpage/gaoptout?hl=de">
        verfügbaren Deaktivierungsoptionen für Google Analytics für das Web
      </a>
      .
      <br />
      Die Website hält sich an die Richtlinien von Google für interessenbezogene Werbung in AdWords
      sowie an die Einschränkungen für sensible Kategorien und: nutzt Remarketing mit Google Analytics
      für Online-Werbung.
      <br />
      Die Website und Drittanbieter, einschließlich Google, verwenden gemeinsam Erstanbieter-Cookies
      (wie z. B. Google Analytics) und Drittanbieter-Cookies (wie z. B. DoubleClick-Cookies), um
      Anzeigen auf der Grundlage früherer Besuche bestimmter Nutzer auf der Website zu aktualisieren,
      zu optimieren und zu schalten.
      <br />
      Die Website und Drittanbieter, einschließlich Google, verwenden gemeinsam Erstanbieter-Cookies
      (wie Google Analytics) und Drittanbieter-Cookies (wie DoubleClick-Cookies), um Berichte darüber
      zu erstellen, wie sich die Anzeigenimpressionen der Website, andere Nutzungen von Werbediensten
      und Interaktionen mit diesen Anzeigenimpressionen und Werbediensten auf Besuche der Website
      auswirken.
      <br />
      Die Website kann Daten aus der interessenbezogenen Werbung von Google oder Zielgruppendaten von
      Drittanbietern (wie Alter, Geschlecht und Interessen) mit Google Analytics verwenden.
      <br />
      Das Unternehmen behält sich das Recht vor, diese Cookie-Richtlinie jederzeit zu ändern. Bitte
      beachten Sie den Punkt „LETZTE ÜBERARBEITUNG“ oben auf dieser Seite, um zu sehen, wann diese
      Cookie-Richtlinie zuletzt überarbeitet wurde. Alle Änderungen an dieser Cookie-Richtlinie treten
      in Kraft, sobald die überarbeitete Cookie-Richtlinie auf der Website verfügbar ist.
      <br />
      Drittanbieter und andere Unternehmen, mit denen wir zusammenarbeiten, können ihre eigenen Cookies
      verwenden, um Informationen über die Aktivitäten der Nutzer auf unserer Website zu sammeln. Es wird
      darauf hingewiesen, dass unser Unternehmen keine Kontrolle über diese Cookies hat.
      <br />
      <br />
      Deaktivierung von Cookies
      <br />
      Sie können Cookies über die Einstellungsoptionen Ihres Browsers aktivieren, deaktivieren oder
      vollständig löschen. Wenn Sie sich dafür entscheiden, Cookies zu deaktivieren, funktionieren einige
      Teile der Website möglicherweise nicht ordnungsgemäß, weshalb die Nutzer diesen Eingriff von
      vornherein akzeptieren. Sie können die Website besuchen, ohne die Verwendung von Cookies
      zugelassen zu haben, aber Sie werden nicht alle Funktionen der Website nutzen oder deren
      spezifische Merkmale genießen können. Um Ihre Cookie-Einstellungen zu ändern, sehen Sie im
      „Hilfe“-Menü Ihres Browsers nach
      <br />
      <br />
      INSBESONDERE in Bezug auf Daten zu durchgeführten Transaktionen.
      <br />
      Wie erteilt der Nutzer seine Einwilligung zur oben genannten Verwendung von Cookies? Wenn der
      Nutzer die Startseite der „Website“ aufruft, wird er auf einen entsprechenden Hinweis zu unserer
      Verwendung von Cookies aufmerksam gemacht, der an prominenter Stelle platziert ist und auf diese
      Nutzungsrichtlinie mit entsprechenden klaren und umfassenden Informationen verweist. Falls der
      Nutzer beschließt, Unterseiten der „Website“ zu besuchen, und sofern er seinen Webbrowser
      ordnungsgemäß konfiguriert hat, erteilt er damit freiwillig seine ausdrückliche und spezifische
      Einwilligung zu dieser Nutzung. Andernfalls muss der Nutzer vom Besuch der „Website“ absehen oder
      die Verwendung von Cookies in den Browsereinstellungen deaktivieren.
      <br />
      <br />
      Wie kann der Nutzer die Verwendung von Cookies deaktivieren?
      <br />
      Falls der Nutzer die Verwendung von Cookies über die Browsereinstellungen aktivieren oder
      deaktivieren möchte, empfehlen wir je nach Browser den Besuch der folgenden Websites, um sich über
      die erforderlichen Schritte zu informieren
      <br />●{' '}
      <a href="https://support.microsoft.com/de-de/windows/l%C3%B6schen-und-verwalten-von-cookies-168dab11-0753-043d-7c16-ede5947fc64d">
        Internet Explorer / Microsoft Edge (Hilfe zu Cookies)
      </a>{' '}
      <br />●{' '}
      <a href="https://support.mozilla.org/de/kb/cookies-loeschen-daten-von-websites-entfernen">
        Firefox
      </a>{' '}
      <br />● <a href="https://support.google.com/chrome/answer/95647?hl=de">Chrome</a> <br />●{' '}
      <a href="https://help.opera.com/de/latest/web-preferences/">Opera</a> <br />●{' '}
      <a href="https://support.apple.com/de-de/guide/safari/sfri11471/mac">
        Safari (macOS)
      </a>
      <br />●{' '}
      <a href="https://support.apple.com/de-de/HT201265">Safari (iOS)</a>
      <br /> <br />
      Schließlich steht unser Unternehmen Ihnen jederzeit für Informationen und/oder weitere Erläuterungen
      sowie für Fragen zur Verfügung, die Sie an uns richten möchten.
    </div>
  );
}

export default CookieGerman;
